import SchoolLogo from "../assets/images/coewarri.png";
import AffiliateLogo from "../assets/images/uniben_logo.png";

export const InstitutionName = "College of Education, Warri";
export const AffiliateName = "University of Benin, Benin City";
export const AFFILIATE_SHORT_NAME = "uniben pg";
export const X_SCHOOL_CODE = "coewarri";
export const AFFILIATE_ID = 7;

export { SchoolLogo, AffiliateLogo };

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const currentSession = "2026/2027";

export const sessionList = [
  "2019/2020",
  "2020/2021",
  "2021/2022",
  "2022/2023",
  "2023/2024",
  "2024/2025",
  "2025/2026",
  "2026/2027",
];

export const paymentTypes = [
  {
    name: "School Fees - Full Payment",
    key: "full_payment",
  },
  {
    name: "School Fees - First Instalment",
    key: "part_payment",
  },
  {
    name: "School Fees - Second Instalment",
    key: "second_installment",
  },
  {
    name: "Late Payment",
    key: "late_payment",
  },
];

export const CertificateOptions = [
  { value: "OND", label: "OND" },
  { value: "HND", label: "HND" },
  { value: "BSC", label: "BSc" },
  { value: "BA", label: "BA" },
];

export const ClassOfDegreeOptions = [
  { value: "First Class", label: "First Class" },
  { value: "Second Class (Upper)", label: "Second Class (Upper)" },
  { value: "Second Class (Lower)", label: "Second Class (Lower)" },
  { value: "Third Class", label: "Third Class" },
];

export const DepartmentList = [
  {
    id: 2,
    name: "POST GRADUATE DIPLOMA IN TECHNICAL EDUCATION ",
    code: "PGDTED",
    faculty: {
      id: 1,
      name: "Faculty of Education",
      code: "FOE",
      programme: null,
    },
  },
  {
    id: 3,
    name: "POST GRADUATE DIPLOMA IN EDUCATION ",
    code: "PGDE",
    faculty: {
      id: 1,
      name: "Faculty of Education",
      code: "FOE",
      programme: null,
    },
  },
];

export const ApplicationSessionList = [
    {
      "id": 1,
      "name": "2024/2025",
      "module": "students",
      "start_date": "2024-08-30",
      "end_date": "2025-08-30",
      "is_active": false,
      "course_modifiable": false,
      "created_at": "2024-09-16T16:32:59.840731Z"
    },
    {
      "id": 2,
      "name": "2025/2026",
      "module": "students",
      "start_date": "2025-08-30",
      "end_date": "2026-08-30",
      "is_active": false,
      "course_modifiable": false,
      "created_at": "2025-09-16T16:32:59.840731Z"
    },
    {
      "id": 3,
      "name": "2026/2027",
      "module": "students",
      "start_date": "2026-08-30",
      "end_date": "2027-08-30",
      "is_active": true,
      "course_modifiable": false,
      "created_at": "2026-09-16T16:32:59.840731Z"
    }
  ]
